import {useEffect,useState,useContext} from 'react'
import { CgClose } from 'react-icons/cg';
import './responseModal.css'

export default function ResponseModal(props){
    //Type => Error = 0 | Success = 1
    // console.log(props?.data?.closeModalFunc)
    return(
        <div className='containerResponseModal'>
            <div className={props?.data?.type == 1? 'containerResponseModalSuccess' : 'containerResponseModalError'}>
                <div className={props?.data?.type == 1? 'headerResponseSuccess' : 'headerResponseError'}>
                    <div></div>
                    <div className='containerResponseCloseButton'>
                        <button className={props?.data?.type == 1? 'closeButtonReponseSuccess' : 'closeButtonReponseError'} onClick={() => {props?.data?.closeModalFunc(false)}}><CgClose className='closeButtonIconOrderPrice' size={24}/></button>
                    </div>
                </div>
                <div className='containerResponseSendModal'>
                    <div className='messageResponseModal'>{props?.data?.message}</div>
                </div>
                <div className='containerOptionsResponseModal'>
                    <button className={props?.data?.type == 1? 'optionSuccessResponseModal' : 'optionErrorResponseModal'} onClick={() => {props?.data?.closeModalFunc(false)}}>fechar</button>
                </div>
            </div>
        </div>
    )
}